// INFO: English ordinal suffix per CLDR ordinal plural category: one → 1st/21st, two → 2nd/22nd, few → 3rd/23rd,
// other → 4th/11th/12th/13th. English never yields `zero` or `many`; they are listed only to keep the Record total.
export const EN_ORDINAL_SUFFIX: Record<Intl.LDMLPluralRule, string> = {
  zero: 'th',
  one: 'st',
  two: 'nd',
  few: 'rd',
  many: 'th',
  other: 'th',
};
